import React, { Component } from "react";

import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import {Picker} from "../Utils/Picker";

class LicenceSection extends Component {
  render() {

    let additionalContacts = (this.props.rental.customer && this.props.rental.customer.id) ? this.props.rental.customer.additional_contacts : [];

    let additionContactObjects = additionalContacts && additionalContacts.length > 0 ? additionalContacts.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

    const onContactChange = e => {
      let driver = additionContactObjects[e.target.value]
      const toUpdate = {
        target: {
          name: e.target.name,
          value: driver
        }
      }
      this.props.onChange(toUpdate);
      // now handle changing all the licence information
      if(driver) {
        let otherDataToChange = {
          licence_number: driver.licence_number,
          ni_number: driver.ni_number,
          licence_type: driver.licence_type,
          licence_held: driver.licence_held,
          licence_expiry_date: driver.licence_expiry_date,
          licence_check_date: driver.licence_checked_date
        }
        this.props.triggerChange(otherDataToChange);
      }
    }

    return (
      <Box>
        <Heading>Licence</Heading>
        <Columns>
          <Columns.Column>
            <Picker
              options={{results: additionalContacts}}
              label={"Licence Holder"}
              value={this.props.rental.driver}
              blank={true}
              name={"driver"}
              optionField={"name"}
              onChange={onContactChange}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Corporate Licence</Form.Label>
            <Form.Checkbox
              checked={this.props.rental.corp_licence}
              onChange={this.props.onCheck}
              name={"corp_licence"}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>N.I. Number</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="ni_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.ni_number}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Licence Number</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="licence_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_number}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Licence Type</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="licence_type"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_type}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Licence Held (Years)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="licence_held"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.licence_held)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Licence Expiry Date</Form.Label>
              <Form.Control>
                <Form.Input
                  type="date"
                  name="licence_expiry_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_expiry_date}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Licence Check Date</Form.Label>
              <Form.Control>
                <Form.Input
                  type="date"
                  name="licence_check_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_check_date}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>License Checked</Form.Label>
              <Form.Control>
                <Form.Checkbox
                  name="licence_checked"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.licence_checked}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>License Copy Taken</Form.Label>
              <Form.Control>
                <Form.Checkbox
                  name="licence_copy_taken"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.licence_copy_taken}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
    );
  }
}

export default LicenceSection;
